import { Component, EventEmitter, HostBinding, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { ConstantsService } from "@app/services/constantsService";
import { animFadeInOut } from "src/app/styles/animations/fade-in-fade-out.animation";
import { animSlideFromLeft } from "src/app/styles/animations/slide-from-left.animation";
import "./sidebar.component.scss";

@Component({
    selector: "sidebar",
    template: require("./sidebar.component.html"),
    animations: [animFadeInOut, animSlideFromLeft]
})
export class SideBarComponent implements OnInit {

    @Input() title: string;
    @Input() subtitle: string;
    @Input() width: string = "40%";
    @Input() loading = false;
    @Input() message: string;
    @Input() messageWarning: boolean;
    @Input() saving = false;

    @Output() onClose: EventEmitter<string> = new EventEmitter();

    @HostBinding('@animFadeInOut') get animFadeInOut() {
        return true;
    }

    @HostBinding('@animSlideFromLeft') get animateIn() {
        return true;
    }

    // ---

    isMobile: boolean;
    justSaved: boolean;

    //--

    constructor(private readonly constantsService: ConstantsService) {
        this.isMobile = this.constantsService.getIsMobile();
    }

    ngOnInit(): void {
        this.width = this.isMobile ? "100%" : this.width;
    }
}
